import { apiResponseMiddleware } from "@/middleware/api-response";

import { apiProfile } from "./axios-instance";
import { ArticleAuthor, ArticleType } from "@/types/article";

const API_ENDPOINT = "/Professor";
const Article_API_ENDPOINT = "/Article";

export const updateArticleWithUrl = async (url: string) => {
  return await apiResponseMiddleware<unknown>(
    apiProfile.post(`${Article_API_ENDPOINT}/ScrapeArticleFromUrl`, null, {
      params: {
        url
      }
    }),
    () => { },
    {
      showToast: false
    }
  );
};

export const updateArticleWithScholarUrl = async (data: {
  input: string;
  userId: number;
}) => {
  return await apiResponseMiddleware<unknown>(
    apiProfile.post(
      `${API_ENDPOINT}/UpdateArticlesWithArticleScholarUrl`,
      null,
      {
        params: {
          ...data
        }
      }
    ),
    () => { },
    {
      showToast: false
    }
  );
};




export const getArticlesByWWorkflowUserId = async (id: string) => {
  const response = await apiResponseMiddleware<ArticleType>(
    apiProfile.get(`/Article/GetArticles`, {
      params: {
        articleId: id,
        language: 1,
      },
    }),
    () => { },
    {
      showToast: false
    }
  );

  return response!.data ?? null;
};

export const getArticlesAuthoeBtArticleAndProfessorId = async (professorId: number, articleId: number) => {
  const response = await apiResponseMiddleware<ArticleAuthor>(
    apiProfile.get(`/Article/GetArticlesAuthoeBtArticleAndProfessorId`, {
      params: {
        articleId: articleId,
        professorId: professorId,
      },
    }),
    () => { },
    {
      showToast: false
    }
  );

  return response!.data ?? null;
};

export const updateArticleAuthorsOrder = async (
  articleId: number,
  authors: { userIdentifierEn: string; order: number }[]
) => {
  await apiResponseMiddleware<unknown>(
    apiProfile.post(`${Article_API_ENDPOINT}/UpdateArticleAuthorsOrder`, {
      articleId,
      authors
    }),
    () => { },
    { showToast: true }
  );

};

export const requestScopusScrape = async () => {
  return await apiResponseMiddleware<void>(
    apiProfile.post(`${Article_API_ENDPOINT}/RequestScopusScrape`),
    () => { },
    { showToast: false }
  );
};